<mat-toolbar class="header">
  <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
    Crear Proveedor
  </div>
</mat-toolbar>

<div class="dialog-wrapper">
  <div #wrapper>
    <form [formGroup]="form" class="form">
      <div class="form-row">
        <mat-form-field>
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
    
        <mat-form-field>
          <mat-label>{{ 'client_identifier' | human }}</mat-label>
          <input matInput appIdentifier formControlName="rut" autocomplete="off">
          <mat-error>
            El {{ 'client_identifier' | human }} es <strong>inválido</strong>
          </mat-error>
        </mat-form-field>
    
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email">
        </mat-form-field>
    
        <mat-form-field>
          <mat-label>Teléfono</mat-label>
          <input matInput formControlName="phone">
        </mat-form-field>
    
        <mat-form-field>
          <mat-label>Dirección</mat-label>
          <input matInput formControlName="address">
        </mat-form-field>
      </div>
    </form>
  </div>
</div>

<mat-toolbar class="footer">
  <button mat-raised-button mat-dialog-close> 
    Cancelar
  </button>
  <div class="expander"></div>
  <button type="button" [disabled]="!form.valid" mat-raised-button (click)="createProvider()">Crear</button>
</mat-toolbar>

